import React from "react";

function Summary() {
  return <div>Summary</div>;
}

export default Summary;
